var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageAlignmentCenter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5 6C19.5 5.17157 18.8284 4.5 18 4.5H6C5.17157 4.5 4.5 5.17157 4.5 6V18C4.5 18.8284 5.17157 19.5 6 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V6ZM6.75 6C6.33579 6 6 6.33579 6 6.75V17.25C6 17.6642 6.33579 18 6.75 18H17.25C17.6642 18 18 17.6642 18 17.25V6.75C18 6.33579 17.6642 6 17.25 6H6.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.675C0 3.30221 0.335787 3 0.75 3C1.16421 3 1.5 3.30221 1.5 3.675V20.325C1.5 20.6978 1.16421 21 0.75 21C0.335787 21 0 20.6978 0 20.325V3.675Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 3.675C22.5 3.30221 22.8358 3 23.25 3C23.6642 3 24 3.30221 24 3.675V20.325C24 20.6978 23.6642 21 23.25 21C22.8358 21 22.5 20.6978 22.5 20.325V3.675Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.74943 12C10.9921 12 11.9994 10.9926 11.9994 9.75C11.9994 8.50736 10.9921 7.5 9.74943 7.5C8.50679 7.5 7.49943 8.50736 7.49943 9.75C7.49943 10.9926 8.50679 12 9.74943 12ZM9.74943 10.5C10.1636 10.5 10.4994 10.1642 10.4994 9.75C10.4994 9.33579 10.1636 9 9.74943 9C9.33522 9 8.99943 9.33579 8.99943 9.75C8.99943 10.1642 9.33522 10.5 9.74943 10.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1938 10.2921C15.9075 9.9927 15.4328 9.98205 15.1334 10.2683L5.25 18.9027L6.74991 19.5L15.6279 11.8708L18 14.25L19.0842 13.2134L16.1938 10.2921Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageAlignmentCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-alignment-center.a392b1ca1894de81e1441ccf2a57ccbd.svg";